import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { Grid, Radio, Typography } from '@material-ui/core';
import { FieldArray } from 'react-final-form-arrays';
import _ from 'lodash';
import QuestionHeader from './QuestionHeader';
import FormTextField from '../form/FormTextField';

const SubmissionSingleChoiceTable = ({ name, number, questionText, questions, answers, readonly, isOptional, allowOwnAnswer, ownAnswerName, values }) => {
  const ownAnswer = index => {
    const value = values ? _.get(values, `${name}.selectedAnswersIds[${index}]`) : null;
    return value === "own";
  };

  return (
    <div className="box">
      <div className="col-sm-12">
        <QuestionHeader name={questionText} number={number} />
        {isOptional && <Typography variant="caption" color="textSecondary">Odpowiedź nie jest wymagana</Typography>}
        <FieldArray name={`${name}.selectedAnswersIds`}>
          {({ meta }) => {
            return (
              <React.Fragment>
                {questions.map((question, index) => (
                  <React.Fragment key={question.id}>
                    <Typography
                      variant="subtitle2"
                      style={{ marginTop: 10, color: '#000' }}
                      inputProps={{ 'aria-label': question.questionText }}
                      gutterBottom>{question.questionText}</Typography>
                      
                    <Grid container spacing={2} justify="flex-start" alignItems="center">
                      <Grid item xs={12}>
                        <Grid container justify="space-between" wrap="nowrap" style={{ overflowX: 'auto' }}>
                          {answers.map(answer => (
                            <Grid key={answer.id} item style={{ textAlign: 'center', minWidth: 80, display: 'flex', flexDirection: 'column' }} xs={1}>
                              <div style={{ flex: 1}}>
                                <Typography variant="caption">{answer.answerText}</Typography>
                              </div>
                              <Field name={`${name}.selectedAnswersIds[${index}]`}>
                                {({ input }) => (
                                  <React.Fragment>
                                    <Radio
                                      disabled={readonly}
                                      name={input.name}
                                      radioGroup={question.id}
                                      value={answer.id}
                                      checked={input.value === answer.id}
                                      color="primary"
                                      inputProps={{ 'aria-label': answer.answerText }}
                                      onClick={event => input.onChange(event.target.value)}
                                    />
                                  </React.Fragment>
                                )}
                              </Field>
                            </Grid>
                          ))}
                          {allowOwnAnswer &&
                            <Grid item style={{ textAlign: 'center' }} xs={1}>
                              <Field
                                name={`${name}.selectedAnswersIds[${index}]`}
                              >
                                {({ input }) => (
                                  <React.Fragment>
                                    <Radio
                                      disabled={readonly}
                                      name={input.name}
                                      radioGroup={question.id}
                                      value="own"
                                      checked={input.value === "own"}
                                      color="primary"
                                      inputProps={{ 'aria-label': ownAnswerName }}
                                      onClick={event => input.onChange(event.target.value)}
                                    />
                                  </React.Fragment>
                                )}
                              </Field>
                            </Grid>}
                        </Grid>
                      </Grid>
                      {ownAnswer(index)
                        ?
                          <Grid item xs={12}>
                              <Field
                                name={`${name}.ownAnswers[${index}]`}
                                placeholder="Wpisz własną odpowiedź"
                                label={ownAnswerName}
                                component={FormTextField}
                                disabled={readonly}
                                fullWidth
                              />
                          </Grid> : null}
                    </Grid>
                  </React.Fragment>)
                  )}
                {meta.touched && meta.error ? <Typography variant="caption" color="error">{meta.error}</Typography> : null}
              </React.Fragment>);
          }
          }
        </FieldArray>
      </div>
    </div>
  );
};

SubmissionSingleChoiceTable.propTypes = {
  name: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  questionText: PropTypes.string.isRequired,
  questions: PropTypes.array.isRequired,
  answers: PropTypes.array.isRequired,
  readonly: PropTypes.bool,
  isOptional: PropTypes.bool,
  allowOwnAnswer: PropTypes.bool,
  ownAnswerName: PropTypes.string,
  values: PropTypes.object.isRequired,
};

export default SubmissionSingleChoiceTable;



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/SubmissionSingleChoiceTable.js